import { useNode, useEditor } from "@craftjs/core";
import React, { useContext } from "react";
import { PostCategoriesSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraEditorContext } from "../../editor/context";
import { GrigoraDashboardContext } from "../../dashboard/context";
import slugify from "slugify";

export const PostCategories = (props) => {
  const { domain, cmsPosts } = useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();

  const {
    linkCategory,
    showTags = false,
    prefixText,
    attachedPrefixText,
    attachedSuffixText,
    linkRel,
    separator,
    maxCategories = 5,
    openCategoryInNewTab = false,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-categories": true,
      [`post-categories-${id}`]: id,
    },
    blockProps.className,
  );

  var LinkTag = linkCategory ? "a" : "div";

  const getAllCategories = () => {
    if (cmsPosts && cmsPosts.length > 0) {
      var allCategories = cmsPosts
        .map((post) => {
          return post?.category;
        })
        .flat();

      // With unique categories with key value
      allCategories = allCategories.filter(
        (category, index, self) =>
          index === self.findIndex((t) => t.label === category.label),
      );

      return allCategories;
    }
    return [];
  };

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostCategories(
        id,
        props,
      )}`}</style>
      {[...Array(maxCategories)].map((category, index) => {
        return (
          <>
            {prefixText && (
              <p className={`prefix ${index === 1 ? "active" : ""}`}>
                {prefixText}
              </p>
            )}
            <LinkTag
              key={`${id}-${index}-${category}`}
              target={
                openCategoryInNewTab
                  ? openCategoryInNewTab
                    ? "_blank"
                    : "_self"
                  : undefined
              }
              className={`link ${index === 1 ? "active" : ""}`}
              rel={linkRel ? linkRel : undefined}
              href="#"
              onClick={(e) => e.preventDefault()}
            >
              <div className="category">
                {showTags && attachedPrefixText && (
                  <p className="attached-prefix">{attachedPrefixText}</p>
                )}
                {showTags ? "Tag" : "Category"} {index + 1}
                {showTags && attachedSuffixText && (
                  <p className="attached-suffix">{attachedSuffixText}</p>
                )}
              </div>
            </LinkTag>
            {separator && index + 1 !== maxCategories && <div>{separator}</div>}
          </>
        );
      })}
    </div>
  );
};

// To Avoid Mangling in Production
PostCategories.displayName = "PostCategories";

PostCategories.craft = {
  name: "Post Categories",
  props: {},
  related: {
    settings: PostCategoriesSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "PostCategories",
    slug: "grigora/post-categories",
  },
};
